import { observable, action, runInAction } from 'mobx'
import { message } from 'hljd'
import API from '@api/hotel/order'
import storeUp from '../store'
class Store {
  id
  @observable feedBack = {}
  @observable DataHistory = []
  @observable DataCome = {}
  @observable DataFail = {}
  @observable success = false

  @observable
  sendData = {
    message: '',
    id: '',
    intent_level: undefined,
    call_result: '1'
  }

  @action
  postData = async params => {
    let { success } = await API.followUp(params)
    runInAction('pt', () => {
      if (success) {
        this.getHistory('id=' + storeUp.id)
      }

      this.sendData = {
        message: '',
        id: '',
        intent_level: undefined,
        call_result: '1'
      }
    })
  }

  @action
  getHistory = async params => {
    let { data } = await API.OrderHistory(params)
    runInAction('gt', () => {
      this.DataHistory = data.list
    })
  }

  @action
  postfollowFail = async params => {
    let { data, msg } = await API.followFail(params)
    runInAction('fail', () => {
      this.DataFail = data
      message.warning(msg)
    })
  }

  @action
  postcomeMerchant = async params => {
    let { data, success, msg } = await API.comeMerchant(params)
    runInAction('fail', () => {
      this.DataCome = data
      if (success) {
        this.success = true
        this.GetOrderFB('id=' + storeUp.id)
        setTimeout(() => {
          this.success = false
        }, 1000)
        storeUp.getInfo('id=' + storeUp.id)
      }
      return message.warning(msg)
    })
  }

  @action
  sendCome = () => {
    this.postcomeMerchant({
      id: storeUp.id
    })
  }

  @action
  sendFail = () => {
    this.postfollowFail({
      id: storeUp.id
    })
  }

  @action
  getH = () => {
    this.getHistory('id=' + storeUp.id)
  }

  @action
  getMessage = e => {
    this.sendData.message = e.target.value
  }

  @action
  getIntent_level = e => {
    this.sendData.intent_level = e
  }

  @action
  getCall_result = e => {
    if (e.target.checked) {
      this.sendData.call_result = '2'
    } else {
      this.sendData.call_result = '1'
    }
  }

  @action
  sendAjax = () => {
    this.sendData.id = storeUp.id
    if (this.sendData.message == '') {
      message.warning('跟进内容未填')
    } else if (this.sendData.intent_level == '') {
      message.warning('请选择客户意向')
    } else {
      this.postData(this.sendData)
    }
  }

  @observable visible = false
  @action
  showModal = () => {
    this.getOrderFeedback('id=' + storeUp.id)
    this.visible = true
  }
  @action
  showModifyModal = () => {
    this.getOrderFeedback('id=' + storeUp.id)
    this.visible = true
  }
  @action
  handleCancel = () => {
    this.visible = false
    Object.assign(this.form, {
      wedding_day: '',
      tables_num: '',
      price: '',
      other_fee: '',
      deposit_money: '',
      id: '',
      contract_money: '',
      backup_table_num: '',
      hotel_hall_id: '',
      eat_time: ''
    })
    this.imgs = []
    this.imgList = []
  }

  @observable imgList = []
  @observable imgs = []
  @observable hotel = storeUp.orderInfo.hotel
  @observable
  form = {
    contract_money: '',
    eat_time: '',
    hotel_hall_id: '',
    id: storeUp.id,
    price: '',
    proof_photos: this.imgList,
    remark: '',
    tables_num: '',
    wedding_day: '',
    backup_table_num: '',
    other_fee: '',
    deposit_money: ''
  }

  @observable
  orderFB = {
    subTime: '暂无',
    contract_money: '暂无',
    eat_time: '暂无',
    hotel_hall: { id: '暂无', name: '暂无' },
    id: '暂无',
    merchant: '暂无',
    price: '暂无',
    status: '暂无',
    tables_num: '暂无',
    wedding_day: '暂无'
  }

  @observable is_exist = 0
  @action
  GetOrderFB = async params => {
    let { data } = await API.GetOrderFB(params)
    runInAction('FB', () => {
      this.feedBack = data
      this.is_exist = data.is_exist
      if (data.is_exist != 0) {
        let _status = ''
        let _subTime = ''
        let _res = '（没有填写内容）'
        switch (parseInt(data.status)) {
          case 0:
            _status = '成单提交'
            _subTime = data.feedback_at
            break
          case 1:
            _status = '成单通过'
            _subTime = data.feedback_at

            break
          case 2:
            if (data.audit_reason != '') {
              _res = '（' + data.audit_reason + '）'
            }
            _status = '成单不通过' + _res
            _subTime = data.feedback_at
            break
          case 3:
            _status = '退单提交'
            _subTime = data.refund_at
            break
          case 4:
            _status = '退单通过'
            _subTime = data.refund_at
            break
          case 5:
            if (data.audit_reason != '') {
              _res = '（' + data.audit_reason + '）'
            }
            _status = '退单不通过' + _res
            _subTime = data.refund_at
            break
        }
        let _hotelName = '暂无'
        let _eatTime = '暂无'
        if (data.hotel_hall) {
          _hotelName = data.hotel_hall.name
        }
        if (data.eat_time != '') {
          _eatTime = data.eat_time
        }

        this.orderFB = {
          subTime: _subTime,
          contract_money: '¥' + data.contract_money,
          eat_time: _eatTime,
          hotel_hall: {
            name: _hotelName
          },
          id: data.id,
          merchant: data.merchant,
          price: '¥' + data.price,
          status: _status,
          tables_num: data.tables_num,
          wedding_day: data.wedding_day
        }
      } else {
        this.orderFB = {
          subTime: '暂无',
          contract_money: '暂无',
          eat_time: '暂无',
          hotel_hall: { id: '暂无', name: '暂无' },
          id: '暂无',
          merchant: '暂无',
          price: '暂无',
          status: '暂无',
          tables_num: '暂无',
          wedding_day: '暂无'
        }
      }
    })
  }
  @action
  PostOrderFB = async params => {
    let { success } = await API.PostOrderFB(params)
    runInAction('PFB', () => {
      this.imgList = []
      if (success) {
        this.visible = false
        this.GetOrderFB('id=' + storeUp.id)
        storeUp.getInfo('id=' + storeUp.id)
        Object.assign(this.form, {
          wedding_day: '',
          tables_num: '',
          price: '',
          other_fee: '',
          deposit_money: '',
          id: '',
          contract_money: '',
          backup_table_num: '',
          hotel_hall_id: '',
          eat_time: ''
        })
        this.imgs = []
        this.imgList = []
        message.success('提交需求成功')
      }
    })
  }

  @observable dataTime
  @action
  setDate = date => {
    this.form.wedding_day = date.format('YYYY-MM-DD')
  }

  @action
  setHall = e => {
    this.form.hotel_hall_id = e
  }

  @action
  setCol = e => {
    this.form.eat_time = e.join(',')
  }

  @action
  setTable = e => {
    this.form.tables_num = e.target.value.replace(/[^0-9]+/, '')
  }

  @action
  setTable_backUp = e => {
    this.form.backup_table_num = e.target.value.replace(/[^0-9]+/, '')
  }

  @action
  setTablePrice = e => {
    this.form.price = e
  }

  @action
  setHPrice = e => {
    this.form.contract_money = e
  }

  @action
  setHdeposit = e => {
    this.form.deposit_money = e
  }

  @action
  setHPrice_other = e => {
    this.form.other_fee = e
  }

  @action
  upImg = (e, i) => {
    this.imgs = this.imgs.concat([e])
    let obj = {
      img: e,
      width: i.width,
      height: i.height
    }
    this.imgList.push(obj)
  }

  @action
  removeImg = index => {
    this.imgs = this.imgs.filter((item, i) => i !== index)
    this.imgList.splice(index, 1)
  }

  @action
  sendForm = () => {
    let reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/

    this.form.proof_photos = this.imgList
    this.form.id = storeUp.id

    if (this.form.wedding_day == '') {
      message.warning('请填写婚期')
    } else if (this.form.hotel_hall_id == '') {
      message.warning('请填写酒店场地')
    } else if (this.form.eat_time == '') {
      message.warning('请填写市别')
    } else if (this.form.tables_num == '') {
      message.warning('请填写桌数')
    } else if (this.form.price == '') {
      message.warning('请填写餐标')
    } else if (!reg.test(this.form.price)) {
      message.warning('餐标填写有误')
    } else if (!reg.test(this.form.other_fee)) {
      message.warning('其他费用填写有误')
    } else if (this.form.contract_money == '') {
      message.warning('请填写婚宴总价')
    } else if (!reg.test(this.form.contract_money)) {
      message.warning('婚宴总价填写有误')
    } else if (this.form.deposit_money == '') {
      message.warning('请填写定金')
    } else if (!reg.test(this.form.deposit_money)) {
      message.warning('定金填写有误')
    } else {
      this.PostOrderFB(this.form)
    }
  }

  @observable tdVisible = false
  @observable tdImgList = []
  @observable tdImgs = []
  @observable
  tdForm = {
    id: '',
    refund_photos: [],
    refund_reason: ''
  }

  @action
  reset = () => {
    this.tdForm = { refund_photos: [] }
    this.tdImgs = []
  }

  @action
  showWin = () => {
    this.tdVisible = true
    this.tdForm.refund_reason = ''
    this.tdImgList = []
    this.tdForm.refund_photos = []
  }
  @action
  hideWin = () => {
    this.tdVisible = false
    this.reset()
  }

  @action
  resInput = e => {
    this.tdForm.refund_reason = e.target.value
  }

  @action
  tdUpImg = (e, i) => {
    this.tdImgs = this.tdImgs.concat([e])
    let obj = {
      img: e,
      width: i.width,
      height: i.height
    }
    this.tdImgList.push(obj)
  }

  @action
  tdRemoveImg = index => {
    this.tdImgs = this.tdImgs.filter((item, i) => i !== index)
    this.tdImgList.splice(index, 1)
  }

  @action
  refundSend = () => {
    this.tdForm.id = storeUp.id
    this.tdForm.refund_photos = this.tdImgList
    if (this.tdForm.refund_reason == '') {
      message.warning('请填写退单原因')
    } else {
      this.refundPost(this.tdForm)
    }
  }

  @action
  refundPost = async params => {
    let { success } = await API.refund(params)
    runInAction('ref', () => {
      if (success) {
        this.tdVisible = false
        this.reset()
        message.success('退单成功')
      }
    })
  }

  @action
  maintain = () => {
    this.tdVisible = true
  }

  @action
  getOrderFeedback = async params => {
    let { data } = await API.GetOrderFB(params)
    const {
      wedding_day,
      tables_num,
      proof_photos,
      price,
      other_fee,
      hotel_hall,
      eat_time,
      deposit_money,
      contract_money,
      backup_table_num,
      id
    } =
      data || {}
    runInAction('orderFB', () => {
      if (data.is_exist) {
        this.form = {
          wedding_day,
          tables_num,
          price,
          other_fee,
          deposit_money,
          id,
          contract_money,
          backup_table_num,
          hotel_hall_id: hotel_hall.id,
          eat_time: eat_time
        }
        this.imgs = proof_photos || []
        this.imgList = proof_photos || []
      }
    })
  }
}

export default new Store()
